import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { Menu } from 'primeng/menu';

@Component({
  selector: 'vnm-actions-menu',
  templateUrl: './actions-menu.component.html',
  styleUrls: ['./actions-menu.component.scss']
})
export class ActionsMenuComponent {
  @ViewChild('menu') menu: Menu;
  @ViewChild('button') button: ElementRef<HTMLButtonElement>;

  @Input() label: string;
  @Input() items: MenuItem[];
  @Input() icon = 'fa fa-fw fa-ellipsis-v';

  get hasItems(): boolean {
    if (this.items) {
      return this.items.length > 0;
    }

    return false;
  }

  prependItem(item: MenuItem) {
    if (!this.items) {
      this.items = [];
    }

    this.items = [item, ...this.items];
  }

  addItem(item: MenuItem) {
    if (!this.items) {
      this.items = [];
    }

    this.items = [...this.items, item];
  }

  removeItem(item: MenuItem) {
    const itemIndex = this.items.indexOf(item);
    if (itemIndex !== -1) {
      this.items.splice(itemIndex, 1);
      this.items = [...this.items];
    }
  }

  toggle(event?: Event) {
    this.menu?.toggle(event);
  }
}
